import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { UtilsModule } from '@vsolv/ui-kit/utils';
import { AppPageConfig, AppPageModule } from '@vsolv/vectors-ui/app-page';
import { BadgeModule } from '@vsolv/vectors-ui/badge';
import { BreadcrumbsModule } from '@vsolv/vectors-ui/breadcrumbs';
import { TableColumn } from '../../lib/models';
import { ConnectedTableDataSourceQueryParams } from '../table/data-source';
import { ConnectedTableComponent } from '../table/table.component';

@Component({
  standalone: true,
  selector: 'vs-connected-table-page',
  templateUrl: './table.page.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, AppPageModule, BadgeModule, BreadcrumbsModule, UtilsModule, ConnectedTableComponent],
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class ConnectedTablePage<Item> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() rowClicked = new EventEmitter<any>(true);
  protected get isListeningToRowClicked() {
    return this.rowClicked.observed;
  }

  @Input() page?: AppPageConfig | null;

  @Input() endpoint?: string | null;
  @Input() columns?: TableColumn<Item>[] | null;
  @Input() queryParams?: ConnectedTableDataSourceQueryParams | null;

  @ViewChild(ConnectedTableComponent) private table?: ConnectedTableComponent<Item>;

  get datasource() {
    return this.table?.dataSource ?? null;
  }
}
